import handleRules from './handle-rule'

export default function (rules, eventBus) {
    const groupedRules = {}
    rules.forEach(rule => {
        let key = rule.trigger_type
        if (key === 'vueevent') {
            key += `:${rule.trigger_option}`
        }
        if (!groupedRules[key]) {
            groupedRules[key] = []
        }
        groupedRules[key].push(rule)
    })

    Object.keys(groupedRules).forEach(key => {
        const [triggerType, triggerOption] = key.split(':', 2)
        const groupRules = groupedRules[key]

        switch (triggerType) {
            case 'vueevent':
                eventBus.$on(triggerOption, async (args) => {
                    const displays = await handleRules(groupRules, eventBus, null, args)
                    return { displays }
                })
                break
            case 'pageview':
                window.addiesaas.ready(async (args) => {
                    const pathAndQuery = window.location.pathname + window.location.search
                    await handleRules(groupRules, eventBus, (rule) => pathAndQuery.match(rule.trigger_option), args)
                })
                break
            case 'domevent':
                // TODO: Implement domevent trigger type for cart rules
                // NOTE: DOM events are tricky with Vue components
            default:
                console.error(`Unsupported cart rule trigger type: ${triggerType}`)
        }
    })
}
